import clsx from 'clsx';
import * as React from 'react';

import localStyles from './Field.module.scss';

interface ErrorProps {
  id?: string;
  className?: string;
  error: string;
}

export const Error: React.FunctionComponent<ErrorProps> = (props) => {
  const { error, id, className } = props;

  return (
    <span id={id} className={clsx(localStyles.error, className)}>
      {error}
    </span>
  );
};
